(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-cart-page]');
    if (!root) return;
    var sectionId = root.getAttribute('data-section-id');
    var body = root.querySelector('[data-cart-root]');

    function change(key, qty) {
      root.classList.add('is-loading');
      fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty, sections: sectionId, sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (cart.sections && cart.sections[sectionId]) {
            var doc = new DOMParser().parseFromString(cart.sections[sectionId], 'text/html');
            var nb = doc.querySelector('[data-cart-root]');
            if (nb && body) body.innerHTML = nb.innerHTML;
          }
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
            if (cart.item_count > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
          });
          root.classList.remove('is-loading');
        })
        .catch(function () { root.classList.remove('is-loading'); });
    }

    root.addEventListener('click', function (e) {
      var rem = e.target.closest('[data-line-remove]');
      if (rem) { e.preventDefault(); change(rem.getAttribute('data-key'), 0); return; }
      var m = e.target.closest('[data-line-minus]');
      var p = e.target.closest('[data-line-plus]');
      if (m || p) {
        var btn = m || p;
        var key = btn.getAttribute('data-key');
        var inp = root.querySelector('[data-line-qty][data-key="' + key + '"]');
        var q = inp ? parseInt(inp.value, 10) || 1 : 1;
        q = m ? Math.max(0, q - 1) : q + 1;
        change(key, q);
      }
    });
    root.addEventListener('change', function (e) {
      var inp = e.target.closest('[data-line-qty]');
      if (inp) { change(inp.getAttribute('data-key'), Math.max(0, parseInt(inp.value, 10) || 0)); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var modal = document.querySelector('[data-schedule-modal]');
    if (!modal) return;
    var openers = document.querySelectorAll('[data-schedule-open]');
    var closers = modal.querySelectorAll('[data-schedule-close]');
    var form = modal.querySelector('#schedule-form');
    var body = modal.querySelector('[data-schedule-body]');
    var done = modal.querySelector('[data-schedule-done]');
    var errors = modal.querySelector('[data-schedule-errors]');
    var dateInput = modal.querySelector('[data-cs-date]');
    var lastFocus = null;

    function openModal() {
      lastFocus = document.activeElement;
      if (body) body.hidden = false;
      if (done) done.hidden = true;
      modal.classList.add('open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      var first = modal.querySelector('input, select');
      if (first) setTimeout(function () { first.focus(); }, 60);
    }
    function closeModal() {
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    openers.forEach(function (b) { b.addEventListener('click', openModal); });
    closers.forEach(function (b) { b.addEventListener('click', closeModal); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('open')) closeModal(); });

    // Prevent past dates
    if (dateInput) {
      var t = new Date();
      var mm = String(t.getMonth() + 1).padStart(2, '0');
      var dd = String(t.getDate()).padStart(2, '0');
      dateInput.min = t.getFullYear() + '-' + mm + '-' + dd;
    }

    // Submit via fetch so success shows in the modal (no full-page reload → avoids the message form also flashing success)
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (errors) { errors.hidden = true; errors.textContent = ''; }
        var btn = form.querySelector('[type="submit"]');
        if (btn) { btn.disabled = true; btn.style.opacity = '.6'; }
        fetch(form.action, { method: 'POST', body: new FormData(form), headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function () { if (body) body.hidden = true; if (done) done.hidden = false; })
          .catch(function () {
            if (errors) { errors.hidden = false; errors.textContent = 'Something went wrong — please try again or message us on WhatsApp.'; }
            if (btn) { btn.disabled = false; btn.style.opacity = ''; }
          });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deal-of-week"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      var h = el.querySelector('[data-cd-h]'), m = el.querySelector('[data-cd-m]'), s = el.querySelector('[data-cd-s]');
      var endAttr = el.getAttribute('data-end');
      function target() {
        if (endAttr) { var d = new Date(endAttr); if (!isNaN(d)) return d; }
        var t = new Date(); t.setHours(24, 0, 0, 0); return t; // next midnight
      }
      var end = target();
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var diff = end - new Date();
        if (diff <= 0) { if (endAttr) { h.textContent = m.textContent = s.textContent = '00'; return; } end = target(); diff = end - new Date(); }
        var totalH = Math.floor(diff / 3.6e6);
        h.textContent = pad(totalH);
        m.textContent = pad(Math.floor(diff % 3.6e6 / 6e4));
        s.textContent = pad(Math.floor(diff % 6e4 / 1000));
      }
      tick();
      setInterval(tick, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const header = document.querySelector('[data-header]');
    const drawer = document.querySelector('[data-drawer]');

    // Sticky scroll state + reveal the gold deals bar only when scrolling UP.
    if (header) {
      const REVEAL_AFTER = 220;
      let lastY = window.scrollY;
      let ticking = false;
      const apply = () => {
        const y = window.scrollY;
        header.classList.toggle('scrolled', y > 40);
        if (y <= REVEAL_AFTER) {
          header.classList.remove('deals-show');      // clean state near the top
        } else if (y < lastY - 3) {
          header.classList.add('deals-show');          // scrolling up
        } else if (y > lastY + 3) {
          header.classList.remove('deals-show');       // scrolling down
        }
        lastY = y;
        ticking = false;
      };
      const onScroll = () => {
        if (!ticking) { window.requestAnimationFrame(apply); ticking = true; }
      };
      apply();
      window.addEventListener('scroll', onScroll, { passive: true });

      // Publish the live header height so sticky page elements (e.g. the mobile
      // filter button) can sit just below it — including while the deals bar
      // animates open/closed.
      const setH = () => document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');
      setH();
      if (window.ResizeObserver) { new ResizeObserver(setH).observe(header); }
      window.addEventListener('resize', setH, { passive: true });
    }

    // Drawer open / close
    if (drawer) {
      const openBtn = document.querySelector('[data-drawer-open]');
      const setOpen = (open) => {
        drawer.classList.toggle('open', open);
        drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
        document.documentElement.style.overflow = open ? 'hidden' : '';
        if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      };
      if (openBtn) openBtn.addEventListener('click', () => setOpen(true));
      drawer.querySelectorAll('[data-drawer-close]').forEach((el) => el.addEventListener('click', () => setOpen(false)));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer.classList.contains('open')) setOpen(false); });

      // Brands accordion inside the drawer
      drawer.querySelectorAll('[data-acc]').forEach((acc) => {
        const head = acc.querySelector('[data-acc-toggle]');
        const body = acc.querySelector('[data-acc-body]');
        if (!head || !body) return;
        head.addEventListener('click', () => {
          const open = acc.classList.toggle('open');
          head.setAttribute('aria-expanded', open ? 'true' : 'false');
          body.style.maxHeight = open ? body.scrollHeight + 'px' : '0';
        });
      });
    }

    // Search panel with predictive (live) results
    const searchPanel = document.querySelector('[data-search]');
    if (searchPanel) {
      const openBtn = document.querySelector('[data-search-open]');
      const input = searchPanel.querySelector('[data-search-input]');
      const results = searchPanel.querySelector('[data-search-results]');
      const predictiveUrl = searchPanel.getAttribute('data-predictive-url') || '/search/suggest';

      const setOpen = (open) => {
        searchPanel.classList.toggle('open', open);
        searchPanel.setAttribute('aria-hidden', open ? 'false' : 'true');
        document.documentElement.style.overflow = open ? 'hidden' : '';
        if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          window.setTimeout(() => { if (input) input.focus(); }, 80);
        } else {
          if (input) input.value = '';
          results.innerHTML = '';
        }
      };

      if (openBtn) openBtn.addEventListener('click', () => setOpen(true));
      searchPanel.querySelectorAll('[data-search-close]').forEach((el) => el.addEventListener('click', () => setOpen(false)));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && searchPanel.classList.contains('open')) setOpen(false); });

      // Debounced predictive fetch via the Section Rendering API
      let timer = null;
      let controller = null;
      const fetchResults = (q) => {
        if (controller) controller.abort();
        if (!q || q.trim().length < 2) { results.innerHTML = ''; return; }
        controller = new AbortController();
        const url = predictiveUrl
          + '?q=' + encodeURIComponent(q)
          + '&section_id=predictive-search'
          + '&resources[type]=product'
          + '&resources[limit]=6';
        fetch(url, { signal: controller.signal })
          .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
          .then((html) => {
            const tmp = document.createElement('div');
            tmp.innerHTML = html;
            const inner = tmp.querySelector('[data-ps]');
            results.innerHTML = inner ? inner.innerHTML : '';
          })
          .catch(() => {});
      };

      if (input) {
        input.addEventListener('input', () => {
          const q = input.value;
          window.clearTimeout(timer);
          timer = window.setTimeout(() => fetchResults(q), 220);
        });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-hero-slider]').forEach(function (root) {
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
      if (slides.length === 0) return;
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hsl-dot]'));
      var autoplay = root.hasAttribute('data-autoplay');
      var interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var i = 0, timer = null;

      function clear() { if (timer) { clearTimeout(timer); timer = null; } }

      function playActiveVideo(slide) {
        var v = slide.querySelector('video');
        if (!v) return;
        try { v.currentTime = 0; } catch (e) {}
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }

      function schedule(slide) {
        clear();
        if (!autoplay || slides.length < 2 || reduce) return;
        var v = slide.querySelector('video');
        if (v) {
          v.loop = false;
          var advanced = false;
          var go = function () { if (advanced) return; advanced = true; next(); };
          v.addEventListener('ended', go, { once: true });
          timer = setTimeout(go, Math.max(interval, 20000)); // safety if 'ended' never fires
        } else {
          timer = setTimeout(next, interval);
        }
      }

      function goTo(n) {
        n = (n + slides.length) % slides.length;
        slides.forEach(function (s, idx) {
          var active = idx === n;
          s.classList.toggle('is-active', active);
          var v = s.querySelector('video');
          if (v && !active) { try { v.pause(); } catch (e) {} }
        });
        dots.forEach(function (d, idx) {
          d.classList.toggle('is-active', idx === n);
          d.setAttribute('aria-selected', idx === n ? 'true' : 'false');
        });
        i = n;
        var cur = slides[n];
        if (!reduce) playActiveVideo(cur);
        schedule(cur);
      }
      function next() { goTo(i + 1); }
      function prev() { goTo(i - 1); }

      var na = root.querySelector('[data-hsl-next]'); if (na) na.addEventListener('click', next);
      var pa = root.querySelector('[data-hsl-prev]'); if (pa) pa.addEventListener('click', prev);
      dots.forEach(function (d, idx) { d.addEventListener('click', function () { goTo(idx); }); });

      root.addEventListener('mouseenter', clear);
      root.addEventListener('mouseleave', function () { schedule(slides[i]); });

      var sx = null;
      root.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      root.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 45) { dx < 0 ? next() : prev(); }
        sx = null;
      });

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) clear(); else schedule(slides[i]);
      });

      goTo(0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lead-popup"]) return;
  try {
    
    (function () {
      var lead = document.querySelector('[data-lead]');
      var tab = document.querySelector('[data-lead-tab]');
      if (!lead) return;
      var KEY = 'ww_lead_done';
      var done = false;
      try { done = localStorage.getItem(KEY) === '1'; } catch (e) {}
      var trigger = parseInt(lead.getAttribute('data-trigger'), 10) || 42;
      var shown = lead.classList.contains('show');

      function showLead() { if (done) return; lead.classList.add('show'); lead.classList.remove('min'); shown = true; }
      function toTab() { lead.classList.remove('show'); lead.classList.add('min'); if (tab) tab.classList.add('show'); }
      function dismiss() { try { localStorage.setItem(KEY, '1'); } catch (e) {} }

      // Show automatically after a successful submit (Shopify reloads with the success state rendered)
      if (lead.querySelector('.lead-success[style*="flex"]')) { lead.classList.add('show', 'done'); dismiss(); }

      var onScroll = function () {
        if (done || shown) return;
        var sc = window.scrollY / (document.body.scrollHeight - window.innerHeight) * 100;
        if (sc >= trigger) { showLead(); window.removeEventListener('scroll', onScroll); }
      };
      window.addEventListener('scroll', onScroll, { passive: true });

      lead.querySelectorAll('[data-lead-close]').forEach(function (b) {
        b.addEventListener('click', function () { toTab(); dismiss(); });
      });
      if (tab) tab.querySelector('[data-lead-reopen]').addEventListener('click', function () {
        lead.classList.add('show'); lead.classList.remove('min'); tab.classList.remove('show');
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-collection-section]');
    if (!root) return;
    const sectionId = root.dataset.sectionId;
    const form = root.querySelector('[data-filter-form]');
    const results = root.querySelector('[data-collection-results]');

    /* ---- mobile filter drawer ---- */
    const fToggle = root.querySelector('[data-filter-toggle]');
    const fScrim = root.querySelector('[data-filter-scrim]');
    if (fToggle && form) {
      const setFilters = (open) => {
        form.classList.toggle('open', open);
        fToggle.classList.toggle('open', open);
        fToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (fScrim) fScrim.classList.toggle('open', open);
        if (window.matchMedia('(max-width: 1024px)').matches) {
          document.documentElement.style.overflow = open ? 'hidden' : '';
        }
      };
      fToggle.addEventListener('click', () => setFilters(!form.classList.contains('open')));
      // Delegated so it keeps working after the form re-renders via AJAX.
      root.addEventListener('click', (e) => { if (e.target.closest('[data-filter-close]')) setFilters(false); });
      if (fScrim) fScrim.addEventListener('click', () => setFilters(false));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && form.classList.contains('open')) setFilters(false); });
    }

    /* ---- view (grid / list) toggle, remembered ---- */
    const vt = root.querySelector('[data-view-toggle]');
    if (vt) {
      const apply = (view) => {
        root.querySelectorAll('[data-product-grid]').forEach((g) => (g.dataset.view = view));
        vt.querySelectorAll('.vt-btn').forEach((b) => b.classList.toggle('is-active', b.dataset.view === view));
      };
      let saved = 'grid';
      try { saved = localStorage.getItem('ww_view') || 'grid'; } catch (e) {}
      apply(saved);
      vt.querySelectorAll('.vt-btn').forEach((b) =>
        b.addEventListener('click', () => { apply(b.dataset.view); try { localStorage.setItem('ww_view', b.dataset.view); } catch (e) {} })
      );
    }

    /* ---- price range slider ---- */
    function initRange(scope) {
      const wrap = scope.querySelector('[data-range]');
      if (!wrap) return;
      const lower = wrap.querySelector('[data-range-lower]');
      const upper = wrap.querySelector('[data-range-upper]');
      const fill = wrap.querySelector('[data-range-fill]');
      const hidLower = wrap.querySelector('[data-range-input-lower]');
      const hidUpper = wrap.querySelector('[data-range-input-upper]');
      const outMin = scope.querySelector('[data-price-min]');
      const outMax = scope.querySelector('[data-price-max]');
      const symbol = (wrap.dataset.symbol || '').trim();
      const money = (n) => (symbol + ' ' + Math.round(n).toLocaleString('en-US')).trim();
      const max = parseFloat(lower.max) || 0;
      const paint = () => {
        let lo = parseFloat(lower.value), hi = parseFloat(upper.value);
        if (lo > hi) { const t = lo; lo = hi; hi = t; }
        fill.style.left = (max ? (lo / max) * 100 : 0) + '%';
        fill.style.right = (max ? 100 - (hi / max) * 100 : 0) + '%';
        if (outMin) outMin.textContent = money(lo);
        if (outMax) outMax.textContent = money(hi);
      };
      const commit = () => {
        let lo = parseFloat(lower.value), hi = parseFloat(upper.value);
        if (lo > hi) { const t = lo; lo = hi; hi = t; }
        hidLower.value = lo > 0 ? lo : '';
        hidUpper.value = hi < max ? hi : '';
        submit();
      };
      lower.addEventListener('input', paint);
      upper.addEventListener('input', paint);
      lower.addEventListener('change', commit);
      upper.addEventListener('change', commit);
      paint();
    }

    /* ---- sort ---- */
    const sortSelect = root.querySelector('[data-sort]');
    const sortInput = form ? form.querySelector('[data-sort-input]') : null;
    if (sortSelect && sortInput) {
      sortSelect.addEventListener('change', () => { sortInput.value = sortSelect.value; submit(); });
    }

    /* ---- submit (AJAX with graceful full-reload fallback) ---- */
    let controller;
    function buildUrl() {
      const params = new URLSearchParams();
      new FormData(form).forEach((v, k) => { if (v !== '') params.append(k, v); });
      // The sort <select> lives outside the form and survives AJAX re-renders, whereas the
      // form's hidden sort_by input is replaced on every update (leaving stale references).
      // Treat the select as the source of truth so sorting keeps working after filters apply.
      if (sortSelect && sortSelect.value) { params.set('sort_by', sortSelect.value); }
      return form.getAttribute('action').split('?')[0] + '?' + params.toString();
    }
    function submit() {
      const url = buildUrl();
      if (!window.fetch || !window.history) { window.location.href = url; return; }
      if (controller) controller.abort();
      controller = new AbortController();
      root.classList.add('is-loading');
      fetch(url + '&section_id=' + sectionId, { signal: controller.signal })
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newResults = doc.querySelector('[data-collection-results]');
          const newForm = doc.querySelector('[data-filter-form]');
          const newCount = doc.querySelector('[data-active-count]');
          if (newResults) results.innerHTML = newResults.innerHTML;
          if (newForm) form.innerHTML = newForm.innerHTML;
          if (newCount) { const c = root.querySelector('[data-active-count]'); if (c) { c.textContent = newCount.textContent; c.classList.toggle('on', parseInt(newCount.textContent, 10) > 0); } }
          window.history.replaceState({}, '', url);
          root.classList.remove('is-loading');
          bindForm();
          if (vt) { let s = 'grid'; try { s = localStorage.getItem('ww_view') || 'grid'; } catch (e) {} root.querySelectorAll('[data-product-grid]').forEach((g) => (g.dataset.view = s)); }
        })
        .catch((e) => { if (e.name !== 'AbortError') window.location.href = url; });
    }

    function bindForm() {
      root.querySelectorAll('[data-facet-input]').forEach((el) => {
        if (el.type === 'checkbox') el.addEventListener('change', submit);
      });
      initRange(root);
      const clear = root.querySelector('[data-facet-clear]');
      if (clear) clear.addEventListener('click', (e) => { e.preventDefault(); window.location.href = clear.getAttribute('href'); });

      // "See more / less" toggle for long filter lists (keeps checked options visible when collapsed)
      root.querySelectorAll('[data-facet-more]').forEach((btn) => {
        const group = btn.closest('[data-filter-group]');
        const extras = group ? group.querySelectorAll('[data-facet-extra]') : [];
        let expanded = false;
        extras.forEach((e) => { if (e.querySelector('input:checked')) expanded = true; });
        const apply = () => {
          extras.forEach((e) => { e.hidden = !expanded && !e.querySelector('input:checked'); });
          btn.textContent = expanded ? btn.dataset.lessLabel : btn.dataset.moreLabel;
        };
        apply();
        btn.addEventListener('click', () => { expanded = !expanded; apply(); });
      });
    }
    bindForm();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-product-section]');
    if (!root) return;
    const isDesktop = () => window.matchMedia('(min-width: 1081px)').matches;

    /* ---- mobile sticky add-to-cart bar ---- */
    const mainAdd = root.querySelector('[data-add-to-cart]');
    const stickyBar = root.querySelector('[data-sticky-buy]');
    if (mainAdd && stickyBar && 'IntersectionObserver' in window) {
      const stickyIO = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          stickyBar.classList.toggle('visible', !entry.isIntersecting);
          stickyBar.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
        });
      }, { threshold: 0 });
      stickyIO.observe(mainAdd);
    }

    /* ---- gallery: rail thumbs + stacked shots; click a thumb to scroll to its shot ---- */
    const railThumbs = Array.from(root.querySelectorAll('[data-gallery-thumb]'));
    const shots = Array.from(root.querySelectorAll('[data-gallery-shot]'));
    const fulls = shots.map((s) => s.dataset.full);
    let current = 0;

    function markActive(i) {
      current = i;
      railThumbs.forEach((t, n) => t.classList.toggle('on', n === i));
      shots.forEach((s, n) => s.classList.toggle('is-active', n === i));
    }

    railThumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => {
        markActive(i);
        const shot = shots[i];
        if (!shot) return;
        // Desktop scrolls the page vertically to the shot; mobile scrolls the horizontal
        // carousel to it. Either way the click jumps straight to that photo.
        if (isDesktop()) {
          shot.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          shot.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      });
    });

    /* Scroll-spy: keep the active thumb in sync with whichever shot is in view. */
    if ('IntersectionObserver' in window && shots.length) {
      const spy = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const idx = shots.indexOf(entry.target);
            if (idx > -1) markActive(idx);
          }
        });
      }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
      shots.forEach((s) => spy.observe(s));
    }

    /* Force-load each shot before it reaches the viewport. Native lazy-loading is unreliable
       for images inside a horizontal scroller (the mobile carousel), which left some watch
       photos blank until interacted with — flipping loading to eager as they approach fixes it. */
    if ('IntersectionObserver' in window && shots.length) {
      const loader = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const img = entry.target.querySelector('img');
          if (img && img.getAttribute('loading') === 'lazy') { img.setAttribute('loading', 'eager'); }
          obs.unobserve(entry.target);
        });
      }, { rootMargin: '600px' });
      shots.forEach((s) => loader.observe(s));
    }

    /* ---- lightbox ---- */
    const lb = root.querySelector('[data-lightbox]');
    const lbImg = root.querySelector('[data-lightbox-img]');
    function openLightbox(i) {
      if (!lb) return;
      current = (typeof i === 'number') ? i : current;
      if (lbImg) lbImg.src = fulls[current] || '';
      lb.classList.add('show');
      lb.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    }
    function closeLightbox() {
      if (!lb) return;
      lb.classList.remove('show');
      lb.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    }
    root.querySelectorAll('[data-lightbox-open]').forEach((b) => b.addEventListener('click', () => openLightbox(parseInt(b.dataset.index, 10) || 0)));
    if (lb) lb.querySelectorAll('[data-lightbox-close]').forEach((b) => b.addEventListener('click', closeLightbox));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeLightbox(); });

    /* ---- hover zoom (desktop, fine pointer) ----
       Uses a high-res background image re-sampled by the browser (crisp),
       instead of transform:scale which just enlarges the low-res raster (blurry). */
    if (window.matchMedia('(min-width: 1081px) and (pointer: fine)').matches) {
      root.querySelectorAll('[data-zoom]').forEach((frame) => {
        const img = frame.querySelector('img');
        if (!img) return;
        frame.style.cursor = 'zoom-in';
        frame.addEventListener('mouseenter', () => {
          var src = (img.currentSrc || img.src).replace(/width=\d+/, 'width=2400');
          frame.style.backgroundImage = 'url("' + src + '")';
          frame.style.backgroundRepeat = 'no-repeat';
          frame.style.backgroundSize = '230%';
          img.style.opacity = '0';
        });
        frame.addEventListener('mousemove', (e) => {
          const r = frame.getBoundingClientRect();
          const x = ((e.clientX - r.left) / r.width) * 100;
          const y = ((e.clientY - r.top) / r.height) * 100;
          frame.style.backgroundPosition = x + '% ' + y + '%';
        });
        frame.addEventListener('mouseleave', () => {
          frame.style.backgroundImage = '';
          img.style.opacity = '';
        });
      });
    }

    /* ---- quantity ---- */
    const qInput = root.querySelector('[data-qty-input]');
    if (qInput) {
      root.querySelector('[data-qty-minus]').addEventListener('click', () => { qInput.value = Math.max(1, (parseInt(qInput.value, 10) || 1) - 1); });
      root.querySelector('[data-qty-plus]').addEventListener('click', () => { qInput.value = (parseInt(qInput.value, 10) || 1) + 1; });
    }

    /* ---- accordions ---- */
    root.querySelectorAll('[data-acc]').forEach((acc) => {
      const head = acc.querySelector('[data-acc-toggle]');
      const body = acc.querySelector('[data-acc-body]');
      if (!head || !body) return;
      if (acc.classList.contains('open')) body.style.maxHeight = body.scrollHeight + 'px';
      head.addEventListener('click', () => {
        const open = acc.classList.toggle('open');
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
        body.style.maxHeight = open ? body.scrollHeight + 'px' : '0';
      });
    });

    /* ---- countdown ---- */
    root.querySelectorAll('[data-countdown]').forEach((el) => {
      const h = el.querySelector('[data-cd-h]'), m = el.querySelector('[data-cd-m]'), s = el.querySelector('[data-cd-s]');
      const endAttr = el.getAttribute('data-end');
      const pad = (n) => (n < 10 ? '0' : '') + n;
      function target() { if (endAttr) { const d = new Date(endAttr); if (!isNaN(d)) return d; } const t = new Date(); t.setHours(24, 0, 0, 0); return t; }
      let end = target();
      function tick() {
        let diff = end - new Date();
        if (diff <= 0) { if (endAttr) { h.textContent = m.textContent = s.textContent = '00'; return; } end = target(); diff = end - new Date(); }
        h.textContent = pad(Math.floor(diff / 3.6e6));
        m.textContent = pad(Math.floor((diff % 3.6e6) / 6e4));
        s.textContent = pad(Math.floor((diff % 6e4) / 1000));
      }
      tick(); setInterval(tick, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["preorder-intro"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var links = document.querySelectorAll('[data-po-jump]');
    var target = document.getElementById('po-form-anchor');
    if (!links.length || !target) return;
    var HEADER_OFFSET = 96;

    links.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var y = target.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    });

    // Mobile sticky pill: reveal after scrolling into the products, hide near the form
    var sticky = document.querySelector('.poi-req-sticky');
    if (sticky) {
      var onScroll = function () {
        var scrolledIn = window.pageYOffset > 480;
        var formNear = target.getBoundingClientRect().top < window.innerHeight * 0.85;
        sticky.classList.toggle('show', scrolledIn && !formNear);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["price-beating"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var params = new URLSearchParams(window.location.search);
    var ours = params.get('ours');
    var item = params.get('item');
    var oursEl = document.getElementById('pb-ours');
    if (ours && oursEl && !oursEl.value) { oursEl.value = ours; }
    var msgEl = document.getElementById('pb-message');
    if (item && msgEl && !msgEl.value) { msgEl.value = 'Re: ' + item + '\n'; }
    // Bring the form into view when arriving from a product page.
    if ((ours || item) && window.location.hash === '#pb-form-anchor') {
      var anchor = document.getElementById('pb-form-anchor');
      if (anchor) { setTimeout(function () { anchor.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 120); }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-recently-viewed]');
    if (!root) return;

    var KEY = 'ww_recently_viewed';
    var current = root.getAttribute('data-current') || '';
    var max = parseInt(root.getAttribute('data-max'), 10) || 10;

    var list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) {}
    if (!Array.isArray(list)) list = [];

    // On a product page, record the current product (most-recent first, deduped).
    if (current) {
      list = list.filter(function (h) { return h && h !== current; });
      list.unshift(current);
      if (list.length > 20) list = list.slice(0, 20);
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    }

    // Render everything except the product currently being viewed.
    var show = list.filter(function (h) { return h && h !== current; }).slice(0, max);
    if (!show.length || !window.fetch) return;

    var grid = root.querySelector('[data-rvp-grid]');

    Promise.all(show.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '?view=card')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return null;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          return doc.querySelector('.card');
        })
        .catch(function () { return null; });
    })).then(function (cards) {
      var any = false;
      cards.forEach(function (card) { if (card) { grid.appendChild(card); any = true; } });
      if (any) {
        root.hidden = false;
        var head = root.querySelector('[data-rvp-head]');
        if (head) head.hidden = false;
        if (window.wwSyncWishlist) window.wwSyncWishlist();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-related]');
    if (!root || !window.fetch) return;
    var url = root.getAttribute('data-rec-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-related-grid]');
        var cur = root.querySelector('[data-related-grid]');
        if (fresh && cur && fresh.children.length) {
          cur.innerHTML = fresh.innerHTML;
          if (window.wwSyncWishlist) window.wwSyncWishlist();
        }
      })
      .catch(function () {});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-reviews]').forEach(function (root) {
      var rail = root.querySelector('[data-rv-rail]');
      var prev = root.querySelector('[data-rv-prev]');
      var next = root.querySelector('[data-rv-next]');
      var pause = root.parentElement.querySelector('[data-rv-pause]');
      if (!rail) return;

      function cardWidth() {
        var card = rail.querySelector('.rv-card, .rv-summary');
        return card ? card.offsetWidth + 16 : 320;
      }
      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -cardWidth(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: cardWidth(), behavior: 'smooth' }); });

      var playing = true, timer = null;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function auto() {
        if (!playing) return;
        if (rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4) {
          rail.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          rail.scrollBy({ left: cardWidth(), behavior: 'smooth' });
        }
      }
      function start() { if (!reduce) { stop(); timer = setInterval(auto, 4000); } }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      if (pause) {
        var label = pause.querySelector('[data-rv-pause-label]');
        var icon = pause.querySelector('[data-rv-pause-icon]');
        pause.addEventListener('click', function () {
          playing = !playing;
          if (playing) { start(); if (label) label.textContent = 'Pause'; if (icon) icon.innerHTML = '<rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/>'; }
          else { stop(); if (label) label.textContent = 'Play'; if (icon) icon.innerHTML = '<path d="M8 5v14l11-7z"/>'; }
        });
      }
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', function () { if (playing) start(); });
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (function () {
    var box = document.querySelector('[data-search-fallback]');
    if (!box || !window.fetch) return;
    var term = (box.getAttribute('data-term') || '').trim();
    if (!term) return;
    var base = box.getAttribute('data-predictive-url') || '/search/suggest';
    var url = base + '?q=' + encodeURIComponent(term)
      + '&resources[type]=product&resources[limit]=10&section_id=search-fallback';

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = doc.querySelector('[data-search-fallback-grid]');
        if (!grid || !grid.querySelector('.product-grid > *')) return;
        box.innerHTML = grid.innerHTML;
        box.hidden = false;
        // We're now showing closest matches, so drop the "nothing found" line and the "0 results" count.
        var emptyText = document.querySelector('[data-search-empty-text]');
        if (emptyText) emptyText.hidden = true;
        var count = document.querySelector('.sp-count');
        if (count) count.hidden = true;
      })
      .catch(function () {});
  })();

  } catch(e) { console.error(e); }
})();
})();
